import { render, staticRenderFns } from "./ResultObstacles.vue?vue&type=template&id=abea47aa&scoped=true"
import script from "./ResultObstacles.vue?vue&type=script&lang=js"
export * from "./ResultObstacles.vue?vue&type=script&lang=js"
import style0 from "./ResultObstacles.vue?vue&type=style&index=0&id=abea47aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abea47aa",
  null
  
)

export default component.exports